export const createSeedEstimatedReachND = (ids: string[]) => ({
  excludes: {
    groups: [],
    operator: 'UNION',
  },
  includes: {
    groups: [
      {
        direct: {
          operator: 'UNION',
          segments: ids.map(id => ({ id })),
        },
        operator: 'INTERSECT',
      },
    ],
    operator: 'INTERSECT',
  },
});
